'use strict';

function resizeWindow() {
	setTimeout(function () {
		equalize();
	}, 500);
}
function scrollDown() {}

$('[data-fancybox]').fancybox({});

// smooth-scroll to top right away
if (window.location.hash) scroll(0, 0);
// void some browsers issue
setTimeout(function () {
	scroll(0, 0);
}, 1);

$(document).ready(function () {

	//Call function with browser is resized.
	$(window).resize(function (event) {
		resizeWindow();
	});
	resizeWindow();

	//Acts when scroll down page.
	/*
     $(window).scroll(function (event) {
     	scrollDown();
 		var top = $(document).scrollTop();
 		if (top > 20) {
 			$('#header').addClass('scroll', 250);
 			$('#header .firstLogo').addClass('logo-type');
 		} else {
 			$('#header').removeClass('scroll', 250);
 			$('#header .firstLogo').removeClass('logo-type');
 		}
 	});
 */

	// smooth scroll
	$('.scroll').on('click', function (e) {
		e.preventDefault();
		$('html, body').animate({
			scrollTop: $($(this).attr('href')).offset().top - $('#header').height()
		}, 1000, 'easeOutExpo');
	});
	if (window.location.hash) {
		$('html, body').animate({
			scrollTop: $(window.location.hash).offset().top - $('#header').height()
		}, 1000, 'easeOutExpo');
	}

	// Main Nav Dropdown
	$("#primary-nav li").hover(function () {

		$(this).addClass("hover");
		$('ul.submenu', this).fadeIn(200);
	}, function () {

		$(this).removeClass("hover");
		$('ul.submenu', this).fadeOut(200);
	});

	//Home page scroll down arrow. If present.
	$('.arrow-home').click(function (event) {
		$('body, html').animate({
			scrollTop: $(window).height() - $('header').outerHeight() }, 800, 'easeOutExpo');
	});

	$(".weddings-meetings").slick({
		arrows: false,
		autoplay: false,
		dots: true,
		fade: true,
		accessibility: false,
		appendDots: $('.wed-meet-nav'),
		customPaging: function customPaging(slider, i) {
			var title = $(slider.$slides[i]).data('title');
			return '<a>' + title + '</a>';
		}
	});

	//Slick Slider
	$('.sym-slides').slick();

	$('#attractions').find('.section-title').click(function () {
		if ($(this).hasClass('open')) {
			$(this).removeClass('open');
		} else {
			$('.section-title').removeClass('open');
			$(this).addClass('open');
		}
		$(this).next().slideToggle('fast');
		$(".description").not($(this).next()).slideUp('fast');
	});

	$('.reasons-slides').slick({
		arrows: false,
		dots: true,
		autoplay: false,
		autoplaySpeed: 4000,
		speed: 500,
		fade: true,
		accessibility: true,
		appendDots: $('.amenities-nav')
	});

	$(".tabs-menu a").click(function (event) {
		event.preventDefault();
		$('.tabs-menu a').removeClass("active");
		$(this).addClass("active");
		var tab = $(this).attr("href");
		$(".tab-content").not(tab).css("display", "none");
		$(tab).fadeIn();
	});

	// START Parallax Animations
	// Init ScrollMagic
	$('body').hasClass('home') ? onlyHome() : false;

	function onlyHome() {
		var controller = new ScrollMagic.Controller();
		// DEER
		var sceneTrip = new ScrollMagic.Scene({
			triggerElement: '#home .main-content .intro-content-home'
		}).setClassToggle('.deer-illustration', 'slide-up').addTo(controller);
		// HAT
		var sceneTrip = new ScrollMagic.Scene({
			triggerElement: '#home .main-content .special-home'
		}).setClassToggle('.hat-illustration', 'slide-up').addTo(controller);
		// HORSESHOE
		var sceneTrip = new ScrollMagic.Scene({
			triggerElement: '#home .main-content .restaurant-home .group'
		}).setClassToggle('.horseshoe-illustration', 'slide-up').addTo(controller);
	}

	$('.terms').click(function (e) {
		if ($(this).hasClass('open-terms')) {
			$(this).removeClass('open-terms');
		} else {
			$('.terms').removeClass('open-terms');
			$(this).addClass('open-terms');
		}
		$(this).next('div.special-full').slideToggle('fast');
		$('div.special-full').not($(this).next()).slideUp('fast');
	});

	$('.booking-trigger').on('click', function (e) {
		$('.booking-widget').animate({ top: "0" }, 500);
	});

	$('.close-icon').on('click', function (e) {
		$('.booking-widget').animate({ top: "-365" }, 500);
	});

	//Event Tracking
	$('.book-now').on('click', function () {
		ga('send', 'event', 'reservations', 'click', 'book now');
	});
	$('.bookNow').on('click', function () {
		ga('send', 'event', 'header widget', 'click', 'book now');
	});

	//Check in and check out datepicker for booking engine
	$("#CheckIn").datepicker({
		changeMonth: true,
		numberOfMonths: 2,
		dateFormat: "mm-dd-yy",
		minDate: 0,
		onSelect: function onSelect(selectedDate) {
			getDate = $(this).datepicker('getDate');
			newDate = new Date(getDate.getTime());
			newDate.setDate(newDate.getDate() + 3);
			$("#CheckOut").datepicker("setDate", newDate);
			$("#CheckOut").datepicker("option", "minDate", selectedDate);
		}
	});
	$("#CheckOut").datepicker({
		changeMonth: true,
		numberOfMonths: 2,
		dateFormat: "mm-dd-yy",
		onSelect: function onSelect(selectedDate) {
			$("#CheckIn").datepicker("option", "maxDate", selectedDate);
		}
	});
});